import { render, staticRenderFns } from "./rentimage.vue?vue&type=template&id=264fa3ca&scoped=true"
import script from "./rentimage.vue?vue&type=script&lang=js"
export * from "./rentimage.vue?vue&type=script&lang=js"
import style0 from "./rentimage.vue?vue&type=style&index=0&id=264fa3ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264fa3ca",
  null
  
)

export default component.exports